import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { push, replace } from 'react-router-redux';
import { connect } from 'omni-common-ui';
import {
  actions as individualDevelopmentPlans,
  accessors as idpAccessors,
} from 'data/IndividualDevelopmentPlans';
import { actions as skillRecommendationActions } from 'data/SkillRecommendation';
import { MID_LEVEL_REPORT } from './routes';
import PropTypes from 'prop-types';

class IndividualDevelopmentPlan extends PureComponent {

  componentWillMount() {
    this._fetchIndividualDevelopmentPlan();
    this._redirectToListView();
    this.props.fetchSkillRecommendationsIfNeeded(this.props.params.groupId);
  }

  componentWillReceiveProps(nextProps) {
    this._fetchIndividualDevelopmentPlan(nextProps);
    this._redirectToListView(nextProps);
  }

  _redirectToListView(props = this.props) {
    const { groupId, firstGroupIdpId } = props;
    if (! props.firstGroupIdpId) return;
    if (props.location.pathname.endsWith('progress-report-hfv4')) {
      props.replaceRoute(this.props.buildRoute(
        `/group/${groupId}` +
        `/progress-report-hfv4/${firstGroupIdpId}`
      ));
    }
  }

  _fetchIndividualDevelopmentPlan(props = this.props) {
    this.props.fetchGroupIndividualDevelopmentPlanListIfNeeded(props.params.groupId);
    if (props.groupIdpId && this.props.isGroupIdpFetched) {
      this.props.fetchIndividualDevelopmentPlanListIfNeeded(props.groupIdpId);
    }
  }


  render() {
    return <div>
      {this.props.children}
    </div>;
  }
}

IndividualDevelopmentPlan.propTypes = {
  children: PropTypes.node,
  params: PropTypes.shape().isRequired,
  firstGroupIdpId: PropTypes.string,
  groupIdpId: PropTypes.string,
  isGroupIdpFetched: PropTypes.bool.isRequired,
  groupId: PropTypes.string.isRequired,
  fetchGroupIndividualDevelopmentPlanListIfNeeded: PropTypes.func.isRequired,
  fetchIndividualDevelopmentPlanListIfNeeded: PropTypes.func.isRequired,
  fetchSkillRecommendationsIfNeeded: PropTypes.func.isRequired,
  pushRoute: PropTypes.func.isRequired,
  replaceRoute: PropTypes.func.isRequired,
  buildRoute: PropTypes.func.isRequired,
  routes: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
};

function getFirstGroupIdpId(groupIdpList) {
  if (groupIdpList.size === 1) {
    return groupIdpList.toList().get(0).id;
  } else if (groupIdpList.size > 1) {
    let firstGroupIdpInfo = groupIdpList.find((groupIdpInfo) =>
      groupIdpInfo.name.toLowerCase() === MID_LEVEL_REPORT);
    if (! firstGroupIdpInfo) {
      firstGroupIdpInfo = groupIdpList.find((groupIdpInfo) => groupIdpInfo);
    }
    return firstGroupIdpInfo && firstGroupIdpInfo.id.toString();
  }
}

function mapStateToProps(state, ownProps) {
  const { groupId, groupIdpId } = ownProps.params;
  const groupIdpList = idpAccessors.getGroupIdpList(state, groupId);
  const isGroupIdpFetched = !! (groupIdpId && idpAccessors.isGroupIdpFetched(state, groupIdpId));

  const firstGroupIdpId = getFirstGroupIdpId(groupIdpList);
  return {
    groupId,
    firstGroupIdpId,
    groupIdpId,
    isGroupIdpFetched,
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign(
    { pushRoute: (path) => dispatch(push(path)) },
    { replaceRoute: (path) => dispatch(replace(path)) },
    bindActionCreators(individualDevelopmentPlans, dispatch),
    bindActionCreators(skillRecommendationActions, dispatch)
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(IndividualDevelopmentPlan);



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/component.jsx